<template>
    <div>
        <el-col :span="13">
            <menu-list @clickMenuCallback="clickMenuCallback" />
        </el-col>
        <el-col :offset="1" :span="10" v-if="currentMenu">
            <menu-operation :currentMenu="currentMenu" />
        </el-col>
    </div>
</template>
<script>
import MenuList from './MenuList'
import MenuOperation from './MenuOperation'
export default {
    components: { MenuList, MenuOperation },
    data: vm=>({
        tables: [], //列表数据
        search: null, //搜索关键字
        currentPage: 1,
        pageSize: 10,
        currentMenu: null, //当前菜单的操作
    }),
    computed: {
        totalElement(){
            return this.tables.length
        }
    },
    methods: {
        getDatas(){},
        add(){

        },
        edit(row){},
        del(row){},
        delConfirm(row){
            this.$confirm('您确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(row)
            }).catch(() => {
                       
            });
        },
        handleSizeChange(val){
            this.pageSize = val
            this.getDatas()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.getDatas()
        },

        clickMenuCallback(val){
            this.currentMenu = null
            setTimeout(() =>{
                this.currentMenu = val
            }, 100)
            
        },
    }
}
</script>